exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-group {\n  min-height: 20px;\n}\n.list-group-item {\n  background-color: #7fa3bb;\n}\n.list-group-item:hover {\n    background-color: #4d7590;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b10a29a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegistryAdmin.vue
// module id = PquC
// module chunks = 1